interface HeroProps {
  onBookingClick: () => void;
}

export default function Hero({ onBookingClick }: HeroProps) {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-teal-50 via-white to-blue-50">
      <div className="absolute inset-0 z-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/1f0d8f5a1b2eed1df6617d0b5b4af023.jpg" 
          alt="理想の笑顔を手に入れた女性" 
          className="w-full h-full object-cover object-top opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-white/95 via-white/80 to-transparent"></div>
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 lg:py-32">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="inline-block">
              <span className="bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold">20代〜50代女性のための目立たない矯正</span>
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
              あの時できなかった<br />
              <span className="text-teal-600">歯列矯正、</span><br />
              今なら誰にも気づかれずに<br />
              始められます
            </h1>
            
            <p className="text-xl md:text-2xl text-gray-700 leading-relaxed">
              透明マウスピースで、理想の笑顔を手に入れる
            </p>

            <div className="bg-gradient-to-r from-teal-500 to-cyan-500 rounded-2xl p-6 shadow-xl">
              <div className="flex items-center justify-center gap-8 flex-wrap">
                <div className="text-center">
                  <div className="text-white text-sm font-medium mb-2">最短期間</div>
                  <div className="text-white text-4xl font-bold">3週間</div>
                </div>
                <div className="w-px h-16 bg-white/30 hidden sm:block"></div>
                <div className="text-center">
                  <div className="text-white text-sm font-medium mb-2">料金</div>
                  <div className="text-white text-4xl font-bold">2万円<span className="text-xl">より</span></div>
                </div>
              </div>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <button onClick={onBookingClick} className="bg-gradient-to-r from-teal-500 to-teal-600 text-white font-bold py-4 px-8 rounded-lg hover:from-teal-600 hover:to-teal-700 transition-all duration-300 shadow-lg hover:shadow-xl text-lg whitespace-nowrap cursor-pointer">
                無料カウンセリング予約
              </button>
              <a href="#benefits" className="border-2 border-teal-600 text-teal-600 font-bold py-4 px-8 rounded-lg hover:bg-teal-50 transition-all duration-300 text-lg text-center whitespace-nowrap cursor-pointer">
                詳しく見る
              </a>
            </div>
            
            <div className="flex items-center gap-6 pt-6">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center bg-teal-100 rounded-full">
                  <i className="ri-shield-check-line text-xl text-teal-600"></i>
                </div>
                <span className="text-sm text-gray-700">20年以上の実績</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center bg-teal-100 rounded-full">
                  <i className="ri-star-fill text-xl text-teal-600"></i>
                </div>
                <span className="text-sm text-gray-700">満足度96%</span>
              </div>
            </div>
          </div>
          
          <div className="relative hidden lg:block">
            <div className="absolute -top-6 -right-6 w-72 h-72 bg-teal-200 rounded-full opacity-20 blur-3xl"></div>
            <div className="absolute -bottom-6 -left-6 w-72 h-72 bg-blue-200 rounded-full opacity-20 blur-3xl"></div>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <a href="#problems" className="w-10 h-10 flex items-center justify-center text-teal-600 cursor-pointer">
          <i className="ri-arrow-down-line text-3xl"></i>
        </a>
      </div>
    </section>
  );
}